import { twMerge } from 'tailwind-merge';

export const ReReplyCircleIcon = ({ className }: { className?: string }) => (
  <svg
    className={twMerge('size-[24px]', className)}
    width="100%"
    height="100%"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect width="56" height="56" rx="28" fill="#B7DFFF" />
    <path
      d="M29.4 36L28.0933 34.6588L31.43 31.2941H21V20H22.8667V29.4118H31.43L28.07 26.0235L29.4 24.6824L35 30.3529L29.4 36Z"
      fill="#2EA3FF"
    />
    <rect x="0.5" y="0.5" width="55" height="55" rx="27.5" stroke="black" strokeOpacity="0.1" />
  </svg>
);
